import "./Footer.scss";
import {Link} from "react-router-dom";
import {PATHS} from "../../../../routers/utils/Paths.links";
import {useI18n} from "../../../../i18n/I18nProvider";
import {NAV_ITEMS} from "../Navbar/navItems";

const SOCIALS = [
    {
        name: "Discord",
        href: "https://discord.gg/GC44JMuAGQ",
        className: "footer-social-discord",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M19.3 5.4A16.5 16.5 0 0015.2 4l-.5 1a15 15 0 00-5.4 0l-.5-1a16.5 16.5 0 00-4.1 1.4C2 9.3 1.3 13.1 1.7 16.8a16.6 16.6 0 005 2.6l1.1-1.7c-.6-.2-1.2-.5-1.7-.8l.4-.3a11.8 11.8 0 0011 0l.4.3c-.5.3-1.1.6-1.7.8l1.1 1.7a16.6 16.6 0 005-2.6c.5-4.3-.8-8-3-11.4zM8.7 14.5c-1 0-1.8-.9-1.8-2s.8-2 1.8-2 1.8.9 1.8 2-.8 2-1.8 2zm6.6 0c-1 0-1.8-.9-1.8-2s.8-2 1.8-2 1.8.9 1.8 2-.8 2-1.8 2z" />
            </svg>
        ),
    },
    {
        name: "YouTube",
        href: "https://www.youtube.com/@YoreLua",
        className: "footer-social-youtube",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M22.5 7.2a2.8 2.8 0 00-2-2C18.8 4.8 12 4.8 12 4.8s-6.8 0-8.5.4a2.8 2.8 0 00-2 2A29 29 0 001.2 12a29 29 0 00.3 4.8 2.8 2.8 0 002 2c1.7.4 8.5.4 8.5.4s6.8 0 8.5-.4a2.8 2.8 0 002-2 29 29 0 00.3-4.8 29 29 0 00-.3-4.8zM9.8 15.1V8.9l5.6 3.1z" />
            </svg>
        ),
    },
    {
        name: "TikTok",
        href: "https://www.tiktok.com/@askold.dayz",
        className: "footer-social-tiktok",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M16.6 2h-3.3v13.4a2.9 2.9 0 11-2.9-2.9c.3 0 .6 0 .9.1V9.2a6.2 6.2 0 105.3 6.2V8.6a7.6 7.6 0 004.4 1.4V6.7a4.4 4.4 0 01-4.4-4.4z" />
            </svg>
        ),
    },
];

// Футер: бренд і соцмережі, розділи сайту, документи
const Footer = () => {
    const { t } = useI18n();

    return (
        <footer className="footer">
            <div className="footer-main">
                <div className="footer-brand">
                    <Link to={PATHS.SHOP} className="footer-logo">ASKOLD</Link>
                    <p className="footer-tagline">{t("footer.tagline")}</p>
                    <div className="footer-socials">
                        { SOCIALS.map((s) =>
                            <a
                                key={s.name}
                                className={`footer-social ${s.className}`}
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={s.name}
                                title={s.name}
                            >
                                {s.icon}
                            </a>
                        )}
                    </div>
                </div>

                <nav className="footer-col" aria-label={t("footer.nav")}>
                    <h5 className="footer-col-title">{t("footer.nav")}</h5>
                    { NAV_ITEMS.map((item) =>
                        <Link key={item.key} className="footer-link" to={item.to}>{t(item.labelKey)}</Link>
                    )}
                </nav>

                <nav className="footer-col" aria-label={t("footer.info")}>
                    <h5 className="footer-col-title">{t("footer.info")}</h5>
                    <Link className="footer-link" to={PATHS.ABOUT}>{t("footer.about")}</Link>
                    <Link className="footer-link" to={PATHS.AGREEMENT}>{t("footer.agreement")}</Link>
                    <Link className="footer-link" to={PATHS.PRIVACY}>{t("footer.privacy")}</Link>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
